export const kitchenDisplayListGet = (response) => {
  if (response && response.data && response.data.success === true) {
    const items = Array.isArray(response.data.data)
      ? response.data.data.map((item) => ({
          id: item.id || null,
          slack: item.slack || '',
          store_id: item.store_id || null,
          kitchen_display_code: item.kitchen_display_code || '',
          code: item.kitchen_display_code || '',
          label: item.label || '',
          name: item.label || '',
          categories: Array.isArray(item.categories)
            ? item.categories.map((id) => parseInt(id))
            : [],
          category_details: Array.isArray(item.category_details)
            ? item.category_details.map((cd) => ({
                id: cd.id || null,
                label: cd.label || ''
              }))
            : [],
          pending_orders_count: item.pending_orders_count ?? 0,
          is_default: item.is_default ?? 0,
          printer_id: item.printer_id || null,
          printer_name: item.printer?.printer_name || item.printer_name || '',
          printer: item.printer || null,
          orange_timer: item.orange_timer || '0',
          red_timer: item.red_timer || '0',
          status: item.status ?? 0,
          status_data: item.status_data ? {
            id: item.status_data.id || null,
            key: item.status_data.key || '',
            value: item.status_data.value || '',
            value_constant: item.status_data.value_constant || '',
            label: item.status_data.label || '',
            color: item.status_data.color || '',
            status: item.status_data.status ?? 0,
            created_at: item.status_data.created_at || '',
            updated_at: item.status_data.updated_at || '',
            created_by: item.status_data.created_by || null,
            updated_by: item.status_data.updated_by || null
          } : null,
          created_at: item.created_at || '',
          updated_at: item.updated_at || '',
          createdAt: item.created_at || '',
          updatedAt: item.updated_at || '',
          created_by: item.created_by && typeof item.created_by === 'object' ? {
            id: item.created_by.id || null,
            username: item.created_by.username || '',
            email: item.created_by.email || '',
            createdAt: item.created_by.createdAt || '',
            updatedAt: item.created_by.updatedAt || ''
          } : null,
          updated_by: item.updated_by && typeof item.updated_by === 'object' ? {
            id: item.updated_by.id || null,
            username: item.updated_by.username || '',
            email: item.updated_by.email || '',
            createdAt: item.updated_by.createdAt || '',
            updatedAt: item.updated_by.updatedAt || ''
          } : null
        }))
      : []
    return {
      success: true,
      total: response.data.total || items.length,
      data: items
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed',
    data: []
  }
}

export const kitchenDisplayDetailsGet = (response) => {
  if (response && response.data && response.data.success === true) {
    const data = response.data.data || {}
    return {
      success: true,
      data: {
        ...data,
        categories: Array.isArray(data.categories)
          ? data.categories.map((category) => {
              // If category is already an object with name, use it
              if (typeof category === 'object' && category.name) {
                return category
              }
              // If category is just an ID, create an object with id
              return {
                id: parseInt(category),
                name: `Category ${category}` // Fallback name
              }
            })
          : []
      }
    }
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed',
    data: {}
  }
}

export const kitchenDisplayCreatePost = (response) => {
  console.log('API Response:', response) // Debug log
  console.log('API Response Data:', response?.data) // Debug log
  console.log('API Response Status:', response?.status) // Debug log

  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Kitchen Display created',
      data: response.data.data || null
    }
  }
  return { success: false, message: 'Failed to create' }
}

export const kitchenDisplayUpdatePut = (response) => {
  console.log('Update API Response:', response) // Debug log

  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Kitchen Display updated',
      data: response.data.data || null
    }
  }
  return { success: false, message: 'Failed to update' }
}

export const kitchenDisplayDeleteDel = (response) => {
  console.log('Delete Model Response:', response)
  if (response && response.data) {
    return {
      success: response.data.success === true,
      message: response.data.message || 'Kitchen Display deleted'
    }
  }
  return { success: false, message: 'Failed to delete' }
}
